import { VoladeumResponse } from 'client/types';

import { Axios } from '../../axios';
import { Indicator } from '../indicators/types';

import { SignalApi } from './types';

export class VoladeumSignal extends Axios {
  async strategy(strategy_id?: number): Promise<VoladeumResponse<SignalApi>> {
    const res = await this.get<VoladeumResponse<SignalApi>>(`/v1/strategies/${strategy_id}/signal`);
    return {
      success: res.success,
      error: res.error,
      data: res.data,
    };
  }
  async strategyIndicator(
    strategy_id: number,
    indicator: Indicator
  ): Promise<VoladeumResponse<SignalApi>> {
    const res = await this.post<VoladeumResponse<SignalApi>>(
      `/v1/strategies/${strategy_id}/indicators/${indicator.indicator_id}/signal`,
      indicator
    );
    return {
      success: res.success,
      error: res.error,
      data: res.data,
    };
  }
}
